import React from "react";
import associaImmagineENomeANomeUtente from "../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente";

const UserAvatarBadge = ({ username, fallbackUsername, size = 28 }) => {
  const effectiveUsername = String(username || fallbackUsername || "").trim();
  const avatar = effectiveUsername
    ? associaImmagineENomeANomeUtente(
        effectiveUsername,
        effectiveUsername,
        Math.max(40, Number(size) * 2),
      )
    : null;
  const displayName =
    String(avatar?.nomeDisplay || effectiveUsername || "Utente non registrato").trim();

  return (
    <span
      className="dib br-100 overflow-hidden tc v-mid ba b--black-10 bg-near-white"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        lineHeight: `${Math.max(0, size - 2)}px`,
        flex: `0 0 ${size}px`,
      }}
      title={effectiveUsername || "Utente non registrato"}
      aria-label={displayName}
    >
      {avatar?.pathImmagine ? (
        <img
          src={avatar.pathImmagine}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      ) : (
        <span className="f7 fw6">{displayName.charAt(0).toUpperCase() || "?"}</span>
      )}
    </span>
  );
};

export default UserAvatarBadge;
